// Form validation helpers
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const DOCUMENT_OPTIONS = [
  'Academic Transcripts',
  'Degree / Diploma Certificate',
  'National ID / Passport',
  'Certificate of Good Conduct',
  'Professional Certificates / Licenses',
  'Reference Letters',
  'Birth Certificate',
  'Teaching License',
  'Police Clearance',
  'Medical Fitness Certificate'
];

export const parseDocumentList = (docs) => {
  if (!docs) return [];
  if (Array.isArray(docs)) return docs;
  try {
    const parsed = JSON.parse(docs);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

export const formatDateTimeLocal = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const validatePhone = (phone) => {
  const phoneRegex = /^250\d{9}$/;
  return phoneRegex.test(phone.replace(/\D/g, ''));
};

export const validateParentId = (id) => {
  return /^\d{16}$/.test(id);
};

export const formatPhone = (phone) => {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 12 && cleaned.startsWith('250')) {
    return `+${cleaned.slice(0, 3)} ${cleaned.slice(3, 5)} ${cleaned.slice(5, 8)} ${cleaned.slice(8)}`;
  }
  return phone;
};

// Error handling
export const getErrorMessage = (error) => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  if (error.response?.status === 401) {
    return 'Unauthorized. Please log in again.';
  }
  if (error.response?.status === 403) {
    return 'Access denied.';
  }
  if (error.response?.status === 404) {
    return 'Resource not found.';
  }
  if (error.response?.status >= 500) {
    return 'Server error. Please try again later.';
  }
  return error.message || 'An error occurred.';
};

// Local storage helpers
export const getAuthToken = () => localStorage.getItem('authToken');
export const setAuthToken = (token) => localStorage.setItem('authToken', token);
export const clearAuthToken = () => localStorage.removeItem('authToken');
